<div class="groups-panel" role="listbox" aria-label="Groups">

  <!-- Header -->
  <div class="groups-panel__header ngkit-flex-container-row"> 
    <div class="groups-panel__title-block">
      <span class="groups-panel__explore ngkit-text-caption">Explore</span>
      <h3 class="groups-panel__title">Groups</h3>
    </div>
    @if (canCreateGroup) {
      <p-button
        styleClass="groups-panel__add ngkit-button ngkit-button-primary ngkit-button-lg"
        icon="pi ds-ngkit-plus"
        iconPos="left"
        label="Create"
        (onClick)="onOpenAddGroup()"
      ></p-button>
    }
  </div>

  <!-- Search -->
  <div class="groups-panel__search">
    <ngkit-search
      class="ngkit-width-full"
      placeholder="Find a group"
      [prepopulatedSearchQuery]="filterText()"
      (searchUpdated)="onSearch($event)"
      (searchCleared)="clearSearch()"
    />
  </div>

  <!-- Managed-by filter -->
  <div class="groups-panel__management-filter">
    <p-selectButton
      class="ngkit-selecttag"
      data-testid="groups-management-filter"
      aria-label="Filter groups by how they are managed"
      [options]="managementFilterOptions"
      [allowEmpty]="false"
      optionLabel="label"
      optionValue="value"
      [ngModel]="managementFilter()"
      (ngModelChange)="onManagementFilterChange($event)"
    />
  </div>

  <!-- States -->
  @if (state.loading()) {
    <div class="groups-panel__state groups-panel__state--loading">Loading groups...</div>
  } @else if (state.error()) {
    <div class="groups-panel__state groups-panel__state--error">
      Failed to load groups
      <div class="groups-panel__error">{{ state.error() }}</div>
    </div>
  } @else if (!state.hasGroups()) {
    <div class="groups-panel__state groups-panel__state--empty">No groups</div>
  } @else if (hasNoMatches()) {
    <div class="groups-panel__state groups-panel__no-results" role="status">No groups match your filters.</div>
  } @else {
    <ul class="groups-panel__items" role="presentation">
      @for (group of groupRows(); track group.id) {
        <li class="groups-panel__item" role="presentation">
          <button
            type="button"
            class="groups-panel__row"
            [class.is-active]="group.id === selectedId"
            [attr.data-group-id]="group.id"
            (click)="onSelect(group.id)"
            role="option"
            [attr.aria-selected]="group.id === selectedId"
            [attr.aria-label]="group.ariaLabel"
          >
            <span class="groups-panel__details">
              <span
                class="groups-panel__name text-truncate"
                [fgaEllipsisTitle]="group.name"
              >{{ group.name }}</span>
              <span class="groups-panel__subtitle">{{ group.subtitle }}</span>
            </span>
            <span class="groups-panel__detail" aria-hidden="true">
              @if (group.isScimManaged) {
                <i
                  class="pi ds-ngkit-lock"
                  data-testid="group-scim-lock-icon"
                  aria-hidden="true"
                ></i>
              }
            </span>
          </button>
        </li>
      }
    </ul>
  }
</div>

<fga-add-group-panel
  [open]="addGroupOpen"
  [groupNames]="groupNames"
  [addingGroup]="addingGroup"
  [addGroupError]="addGroupError"
  (addGroup)="onAddGroup($event)"
  (closePanel)="onCloseAddGroup()">
</fga-add-group-panel>